import { Box, Typography } from "@mui/material";
import ResultsPanel from "./ResultsPanel";
import ViewerPanel from "./ViewerPanel";
// import { useDispatch } from "react-redux";
// import { getDocumentData } from "../../../store/actions/documentAction";
// import { useState, useEffect } from "react";
// import { useSelector } from "react-redux";

export default function MainContent({selectedDoc,setSelectedDoc}) {
  // const dispatch = useDispatch();
//   const ordersLocation = useSelector(
//     ({ orderReducer }) => orderReducer.ordersLocation
// );

  // useEffect(() => {
  //   const payload = {
  //     searchType: 2,
  //     page: 1,
  //     size: 2000,
  //     locationNumber: [ordersLocation?.locationNumber],
  //     // docTypeCode: [105, 104],
  //     // sortBy: "billedDate",
  //     // sortOrder: "DESC",
  //     // dateFilters: []
  //   };

  //   dispatch(getDocumentData(payload)); // :white_check_mark: API call on load
  // }, [dispatch,ordersLocation]);
  return (
    <Box flex={1} display="flex" flexDirection="column" height='100%'>
      {/* Page Title */}
      <Box px={2} py={1} borderBottom="1px solid #ddd" style={{textAlign:'center'}}>
        <Typography variant="h6" fontWeight={600} color="#0911A7">
          Document Search
        </Typography>
      </Box>

      {/* Content Area */}
      <Box display="flex" flex={1}>
        <ResultsPanel setSelectedDoc={setSelectedDoc}/>
        <ViewerPanel selectedDoc={selectedDoc}/>
      </Box>
    </Box>
  );
}